import { ApiService } from './api.services';
import { BaseService } from 'app/core/base.service';
import { TermoResgate } from '../models/termoResgate.model';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { TermoPerfil } from '../models/TermoPerfil.model';
import { ViewModelFiltraProcesso } from '../models/ViewModelFiltraProcesso.model';
import { ViewModelAtualizarConfig } from '../models/viewModelAtualizarConfig.model';

export class WebTempTermoPerfilService extends ApiService implements BaseService<TermoPerfil>{

    private strAction = 'api/WebTempTermoPerfil';

    constructor(
        httpClient: HttpClient,
        private route: Router) {
        super(httpClient, route);
    }

    getAll(): Observable<TermoPerfil[]> {
        return this.get<TermoPerfil[]>(this.strAction + `/GetAll`);
    }

    deleteById(idTermo: number) {
        return this.post(this.strAction + `/DeleteById?id=${idTermo}`);
    }

    Post(TermoPerfil: TermoPerfil): Observable<TermoPerfil[]> {
        return this.post<TermoPerfil[]>(this.strAction + `/Criar`, TermoPerfil);
    }

    getById(id: number): Observable<TermoPerfil> {
        return this.get<TermoPerfil>(this.strAction + `/GetById/${id}`);
    }

    
    PostFiltroTermoPerfil(viewModelFiltraProcesso: ViewModelFiltraProcesso): Observable<TermoPerfil[]> {
        return this.post<TermoPerfil[]>(this.strAction + `/PostFiltroTermoPerfil`, viewModelFiltraProcesso);
    }

    
    getByCpf(cpf : string): Observable<TermoPerfil[]> {
        return this.get<TermoPerfil[]>(this.strAction + `/GetByCpf?nrCpf=${cpf}`);
    }

    retornarConfig(): Observable<ViewModelAtualizarConfig> { 
        return this.get<ViewModelAtualizarConfig>(this.strAction + `/RetornarConfig`);
    }

    Atualizar(viewModelAtualizarConfig: ViewModelAtualizarConfig): Observable<void> {
        return this.post<void>(this.strAction + `/AtualizarConfig`, viewModelAtualizarConfig);
    }

    Put(TermoPerfil: TermoPerfil): Observable<TermoPerfil> {
        return this.post<TermoPerfil>(this.strAction + `/Put`, TermoPerfil);
    }



}